const whoAreWe = {
    ask: `Who are we?`,
    answer: `Cleanfox is the most practical and ecological app to automatically delete from polluting newsletters. With Cleanfox, not only do you clean your mailbox, but you also reduce your carbon footprint !

Cleanfox is a product developed by [Foxintelligence](https://www.foxintelligence.fr/).
We specialise in e-commerce market research. We market anonymised data for statistical purpose.`
}

const howDoesCleanfoxWorks = {
    ask: `How does Cleanfox works?`,
    answer: `The operation of Cleanfox is very simple. Our algorithm scans your mailbox and detects newsletters and order confirmation emails. Then, Cleanfox offers you to sort your emails according to three options:

*(1) delete your old emails :* allows you to keep your newsletter subscription while placing your old emails in the trash of your mailbox.

*(2) delete your old emails and automatically delete newsletters:* allows you to delete automatically your newsletter while placing your old emails in the trash of your mailbox. In addition, in the event that the sender continues to send you emails, we will place the next emails directly into the basket of your mailbox.

*(3) keep your emails*.

In a few clicks, you clean your mailbox and reduce your digital pollution !`
}

const howMuchDoesCleanfoxCost = {
    ask: `How much does Cleanfox cost?`,
    answer: `Cleanfox is completely free, from download to use.

To learn more about how we are profitable, please visit this page [for more information](my-data).`
}

const whatLanguagesIsCleanfoxAvailableIn = {
    ask: `What languages is Cleanfox available in?`,
    answer: `For the moment, Cleanfox is available in English, French, German and Spanish. We are working to make Cleanfox available in as many languages as possible.`
}

const howDoWeMakeMoney = {
    ask: `How do we make money?`,
    answer: `Our business model is simple: we offer anonymized data for statistical purpose for sale to various economic operators.

please visit this page [for more information](my-data).`
}

const whichDevicesCanIUseCleanfoxOn = {
    ask: `What devices can I use Cleanfox on?`,
    answer: `You can use Cleanfox from your mobile devices and computers: smartphones, tablets, laptops and desktop computers.

For smartphones and tablets : Cleanfox is available in application format, directly downloadable from the PlayStore for Android devices and the App Store for Apple devices.

If you have a Gmail or Microsoft account (Hotmail, Outlook ...), we recommend that you use the application because the connection is easier.

For computers : Cleanfox is available directly from your web browser at : [cleanfox.io](https://www.cleanfox.io/)`
}

const howDoIDownloadTheCleanfoxOnMyMobile = {
    ask: `How do I download the Cleanfox on my mobile?`,
    answer: `Android: You can download the mobile application via the Android PlayStore at the following address: [https://play.google.com/store/apps/details?id=io.cleanfox.android&hl=en](https://play.google.com/store/apps/details?id=io.cleanfox.android&hl=en)

Apple: You can download the mobile application via the Apple App Store at the following address: [https://apps.apple.com/en/app/cleanfox-anti-spam-pub/id1136298377](https://apps.apple.com/en/app/cleanfox-anti-spam-pub/id1136298377)

The download is free of charge.

The Cleanfox application is only downloadable for mobile devices or tablets. If you use a computer, you can access Cleanfox directly via your web browser at the following address [cleanfox.io](http://cleanfox.io/)`
}

const howDoICreateACleanfoxAccount = {
    ask: `How do I create a Cleanfox account?`,
    answer: `Once on the Cleanfox mobile app or on [cleanfox.io](http://cleanfox.io/), click on "Start" then enter your email address and click on "Next". You will have access to our terms and conditions of use, which you can read. As soon as we have your consent, we will offer to create an account for you.

For reasons of security and confidentiality, creating a Cleanfox account is done in several steps. All steps are specified directly on the application. Be careful to follow them carefully.

The steps vary slightly depending on your email provider, however they follow the same logic:

1. First you need to activate the two-step validation. To do this, click directly on the link that will be suggested to you in the application.
2. Then, you need to create an application password from your mailbox. A link is also suggested to you at this stage to save you time.

Once these two steps have been validated, enter the application password that you have just generated.

Your Cleanfox account is created! Follow the tutorial then start your cleaning.

For more details on how to create an account from a **Gmail address**, go [here.](#question-2-7)

For details on how to create an account from an **Outlook or Hotmail** address, go [here.](#question-0-8)

ℹ️ If you are still encountering connection problems, do not hesitate to contact support at the following email address: [contact@cleanfox.io](mailto:contact@cleanfox.io)`
}

const howDoesTheRegistrationProcessWork = {
    ask: `How does the registration process work?`,
    answer: `Registration is very easy and fast :

1. Click on the "Start" button on our homepage.
2. Enter the address of the mailbox you wish to clean up.
3. Follow the login steps. For more help with this, please visit our [dedicated page](#question-2-1).
4. After giving us limited access, Cleanfox will automatically scan your mailbox and create a list of newsletters you have subscribed to. This may take a little while.
5. As soon as the scan is done, you will automatically get a short tutorial to learn how to sort your mails.
6. Once the tutorial is finished, you can click on "Clean my mailbox". You will then have access to the list of newsletters you receive and will be able to clean your inbox. That's it, it's done!`
}

const iVeAlreadyUsedCleanfoxBeforeHowDoILogBackIn = {
    ask: `I've already used Cleanfox before. How do I log back in?`,
    answer: `If you already have a Cleanfox account, you can quickly log back in without having to go through dual authentication again.

Go to Cleanfox and **click on *"I've already used Cleanfox "*** at the right and up side of Cleanfox landing page. You will receive an email with a reconnection link. Click on it. You are now connected to Cleanfox again!`
}

const iForgotMyPassword = {
    ask: `I forgot my password`,
    answer: `No need for a password to log back in to Cleanfox! We wanted to make things easy for our users. To reconnect to Cleanfox, click on ***"I already have a Cleanfox account".*** You do not need a password at this stage. A login link will be sent directly to your mailbox.

Note that the login link **is only valid for one hour**. After this time, you will need to request a login link again.

However, if you don't want to go through the login link, you can restart the account creation steps by clicking on "Start". These steps are detailed [here](#question-2-1).`
}

const cleanfoxDoesntRecognizeMyEmailAddress =  {
    ask: `Cleanfox doesn't recognize my email address`,
    answer: `When creating your account, you may receive the following error message: *"Oops, ... is not an email address processed by Cleanfox".*

Indeed, **Cleanfox does not process personalized email addresses** *(example: [jeanne@dupont.fr](mailto:jeanne@dupont.fr))* and is not compatible with some email providers.`
}

const  theScanRunsInALoop = {
    ask: `The scan runs in a loop`,
    answer: `When you use Cleanfox for the first time, we scan your entire mailbox for newsletters and other unwanted recipients. Once this step has been completed, you can start sorting your emails.
However, sometimes the scan can run in a loop for several hours. If you consider the wait too long, you can ask our technical teams to force the end of the scan so that you can start sorting your emails without waiting.

Send an email to: [contact@cleanfox.io](mailto:contact@cleanfox.io) and we will answer you as soon as possible.

However, please note that it takes an average of 30 minutes to 3 hours for the scan to be completed.`
}

const howDoICreateACleanfoxAccountWithAGmailAddress = {
    ask: `How do I create a Cleanfox account with a Gmail address?`,
    answer: `To securely connect your mailbox to Cleanfox, you will need to create a unique password, called an application password, which will allow Cleanfox to access your emails to be sorted without knowing your personal password.

**For this, 2 to 3 steps will be necessary**. They are detailed directly on the Cleanfox application. We advise you to follow them from your app. In case of problem, we summarize the steps here:

## SIGNING UP FROM YOUR COMPUTER

### **Step 1: Activate IMAP**

This step is necessary for Cleanfox to detect your newsletters.

1. **Click directly on the link** in the Cleanfox app, or go to your Gmail inbox, then **"Settings "** and **"Forwarding and POP/IMAP "**.
2. In the **IMAP Access** section, choose **Activate IMAP Protocol**.
3. Click on **Save Changes** at the bottom of the page (⚠️ remember this important step).
4. Go back to the Cleanfox application and click on **I have validated this step.**

### **Step 2: Activate the 2-step validation**.

Gmail's 2-step validation ([2FA](https://www.google.com/landing/2step/?hl=fr)) allows you to protect your account with a **password.**

1. **Click directly on the link provided** in the Cleanfox app.
2. Sign in to your Google Account with your Gmail username and password.
3. You'll be automatically returned to two-step checkout. Click **ACTIVATE** to activate two-step checkout.
4. Return to the Cleanfox application and click **I have validated this step.**

### **Step 3: Create an app password**

1. **Click directly on the proposed link** in the Cleanfox application
2. **Login back into your Google Account** with your Gmail username and password.
3. You'll be asked to select the application and device for which you want to generate the application password. In "select an application," choose "other" and enter "Cleanfox.
4. Then click on **Generate.**
5. **5. Copy the application password and keep it safe.** Do not lose it until the connection is complete!
6. Go back to the Cleanfox application and click on **I have validated this step.**
7. Click on **"I have validated all these steps "**.
8. Sign in by re-entering your Gmail address and **your application password** that you previously copied.
9. Then click **Next.**

You're finally done! **Your account is finally secure**. **Your mailbox is then scanned by Cleanfox. At the end of the scan, you can start sorting your mails !**

You can finally [learn how to use Cleanfox](#question-0-0) to efficiently delete your emails!

ℹ️If you are still encountering connection problems, do not hesitate to contact the support at the following email address: [contact@cleanfox.io](mailto:contact@cleanfox.io)

## SIGNING UP FROM YOUR MOBILE

We've done everything we can to make it easy to connect via our mobile application. Thus, the number of steps is reduced, because we have automated certain procedures.

### **Step 1: Activate the 2-step validation**

Gmail's 2-step validation ([2FA](https://www.google.com/landing/2step/?hl=fr)) allows you to protect your account using a **password** and your **phone.**

The 2-step validation can be done directly from the Cleanfox mobile app. Follow the steps displayed on your screen.

1. Click on "Let's go". You will automatically be redirected to your Google account.
2. **Enter your email address and then your Google password**.
3. Go to your Gmail application. **Click 'Yes' in the invitation** you received.
4. Once the connection is approved, go back to the Cleanfox app. 

### **Step 2: Create an app password and enable IMAP automatically**

This password is generated by Google for Cleanfox only.

1. Once on the Cleanfox application, re-connect to your Gmail account to activate the two-step validation by inserting **your Gmail password.**
2. Click **Automatically Generate.** Wait a few seconds.
3. Click **Next Step**.
4. Click **Activate Automatically.** This activates the **IMAP protocol,** necessary for Cleanfox to detect your newsletters.
5. Then click **Go** to log in.
6. Your application password is filled in automatically, click **Next**.

You're finally done! **Your account is finally secure** **Your mailbox is then scanned by Cleanfox. At the end of the scan, you can start sorting your mails !**

You can finally [learn how to use Cleanfox](#question-0-0) to efficiently delete your emails!

You will find more information on [our blog](https://cleanfox.io/blog/gmail-tips/how-to-log-into-cleanfox-with-a-gmail-address/).

ℹ️If you are still encountering connection problems, do not hesitate to contact the support at the following email address: [contact@cleanfox.io](mailto:contact@cleanfox.io)`
}

const howDoICreateACleanfoxAccountWithAMicrosoftAddress = {
    ask: `How do I create a Cleanfox account with a Microsoft address (Outlook, Hotmail)?`,
    answer: `To securely connect your mailbox to Cleanfox, you will need to create a unique password, called an application password, which will allow Cleanfox to access your emails to be sorted without knowing your personal password.

**For this, 2 to 3 steps will be necessary**. They are detailed directly on the Cleanfox application. We advise you to follow them directly from your application. In case of problem, we summarize the steps here:

## **How to connect to Cleanfox?**

Just perform 2 steps outside of Cleanfox, directly from your Hotmail / Outlook account. We will accompany you every step of the way.

## SIGNING UP WITH YOUR COMPUTER

## Step 1: Enable two-step verification

The two-step verification of [Microsoft](https://outlook.live.com/owa/) allows you to protect your account with a **password** and your **phone.**.

First, log into your Hotmail/Outlook account on the [Cleanfox.](http://cleanfox.io/) site. To do so, **enter your email address.**

❓Si you have already activated the double authentication on your Microsoft account, confirm the code received by message and **go directly to step 2** to create an application password.

Otherwise, you will need to activate the 2-step verification, to do so follow the next steps:

1. **Click directly on the link provided** in the Cleanfox application.
2. Enter your Microsoft account password.
3. Once you have logged into your Microsoft account, you will be taken to the "Configure your smartphone with an application password" page. Click "Next" until you get to the "Additional Security Options" page.
4. Scroll down to section **"Two Step Verification".**
5. Click **"Configure Two-Step Verification" and then follow Microsoft's instructions**.

**Note**: There are two options for enabling two-step verification with your Microsoft account.

1. **Have a second email address**, different from the one used for your Microsoft account. 2.
2. **Use your mobile number**, you will then need to install the [Microsoft Authenticator] application ([https://www.microsoft.com/fr-fr/account/authenticator](https://www.microsoft.com/fr-fr/account/authenticator)) to associate your account with your phone number.

Finally, go back to the Cleanfox application and click on **I have validated this step.**

## Step 2: Create an application password

For the second step, you will need to **generate an application password.** To do this, follow the steps below:

1. **Click directly on the proposed link** in the Cleanfox application.
2. You will come to the page "Use this application password for login".
3. **Copy the displayed application password** and return to Cleanfox.
4. Click on **"I have completed all steps "**.
5. Sign in by re-entering your Gmail address and **your application password** that you previously copied.
6. Then click **Next.**

You're finally done! **Your account is finally secure**. **Your mailbox is then scanned by Cleanfox. At the end of the scan, you can start your sorting !**

ℹ️If you are still encountering connection problems, do not hesitate to contact the support at the following email address: [contact@cleanfox.io](mailto:contact@cleanfox.io)

## SIGNING UP WITH YOUR MOBILE

## Step 1: Enable two-step verification

The two-step verification of [Microsoft](https://outlook.live.com/owa/) allows you to protect your account with a **password** and your **phone.**

1. Go to your Cleanfox application and click Start.
2. Enter your Microsoft email address.
3. A summary of the steps will be displayed. Click Next and then **"I got it!".**
4. You will be redirected to your Microsoft account. Fill in **your Microsoft password.

❓Si you have already activated dual authentication on your Microsoft account, you must go to your Microsoft Authenticator application to approve the application.

**If not, you will need to activate 2-step verification**, to do so follow these steps:

1. **Click directly on the link provided** in the Cleanfox application.
2. Enter your Microsoft account password.
3. Once you have logged into your Microsoft account, you will be taken to the "Configure your smartphone with an application password" page. Click "Next" until you get to the "Additional Security Options" page.
4. Scroll down to section **"Two Step Verification".**
5. Click **"Configure Two-Step Verification" and then follow Microsoft's instructions**.

**Note**: There are two options for enabling two-step verification with your Microsoft account.

1. **Have a second email address**, different from the one used for your Microsoft account. 2.
2. **Use your mobile number**, you will then need to install the [Microsoft Authenticator] application ([https://www.microsoft.com/fr-fr/account/authenticator](https://www.microsoft.com/fr-fr/account/authenticator)) to associate your account with your phone number.

Finally, go back to the Cleanfox application and click on **I have validated this step.**

### **Step 2: Create an app password automatically**

Microsoft will automatically send you back to Cleanfox.

1. Click **Automatically Generate.** Wait a few seconds.
2. Click on **"Let's go!"**
3. You will arrive on a "Connect your mailbox" page. The application password will be automatically pasted. Click **Next.**

You're finally done! **Your account is finally secure**. **Your mailbox is then scanned by Cleanfox. At the end of the scan, you can start your sorting !**

You can finally [learn how to use Cleanfox](#question-0-0) to delete your emails efficiently!

You can find more information on [our blog](https://cleanfox.io/blog/hotmail-outlook-tips/how-do-i-connect-to-cleanfox-with-an-outlook-hotmail-address/).

ℹ️If you always encounter connection problems, do not hesitate to contact the support at the following email address: [contact@cleanfox.io](mailto:contact@cleanfox.io)`
}

const howToCleanMyEmailsWithCleanfox = {
    ask: `How to clean my emails with Cleanfox? (tutorial)`,
    answer: `It couldn't be simpler. There are three sorting options and two views available:

1. **The "card** **view"** which allows you to sort your mails one by one, displayed as cards. To sort your mails, 3 movements:
- **Slide to the left to automatically delete**. This option places the mails of the newsletter in the trash of your mailbox and automatically delete you to this newsletter.
- **Swipe up to delete.** This option places the received mails in the trash of your mailbox but keeps your subscription to the newsletter.
- **Slide to the right to keep**. This option keeps all the emails and the newsletter subscription.

2. **The "list view "** which displays the list of all the newsletters to be sorted and allows you to select multiple emails at a time. Here, to sort, simply tick the newsletter(s) of your choice and click on :

- **The red circle to automatically delete**. This option places the emails of the newsletter in the basket of your mailbox and automatically delete you to this newsletter.
- **The orange bin to delete.** This option places the emails received in the basket of your mailbox but keeps your subscription to the newsletter.
- **The green box to keep**. This option keeps all the mails and the subscription to the newsletter.`
}

const iWouldLikeToSortThroughSeveralMailboxesAtTheSameTime = {
    ask: `I would like to sort through several mailboxes at the same time`,
    answer: `To add another mailbox, just go to your **settings,** then **"your mailboxes"**, and click on **"add a mailbox".**

This will allow you to sort several mailboxes at the same time. All the mails will be displayed in the same list, and the mailbox concerned will be indicated.`
}

const iWouldLikeToUnderstandMyStatistics = {
    ask: `I would like to understand my statistics`,
    answer: `While cleaning your mailbox, Cleanfox calculates three statistics:

1. The number of newsletters you have automatically deleted
2. The number of emails deleted
3. The number of CO2 saved per year. 1 mail deleted corresponds to 10 grams of CO2 saved per year.

If you make online purchases, Cleanfox also analyses their carbon impact on the planet, so that you can move towards more responsible consumption, if you are interested.`
}

const iDeletedAnEmailByMistakeHowCanIRetrieveIt = {
    ask: `I deleted an email by mistake. How can I retrieve it?`,
    answer: `Mails that Cleanfox deletes are not directly deleted from your mailbox. You can find them in **the trash of your mailbox** and retrieve the emails you accidentally deleted. 

**Depending on the email provider, you have 5 to 30 days before your recycle bin empties automatically.** For example, Gmail removes items from the recycle bin that are older than 30 days.

As for the newsletters you have deleted, you can find them in **My Actions**, on the top right of your screen. More information about this in [I automatically deleted a newsletter by mistake. How can I retrieve it?](#question-3-9)`
}

const whyDoNewslettersThatIHaveDeletedStillAppearInMyMailbox = {
    ask: `Why do newsletters that I have deleted still appear in my mailbox?`,
    answer: `To unsubscribe from some newsletters, you need to fill in your email and password, which can make it difficult for us to unsubscribe without any mistakes. Thus, we chose to automatically delete your incoming unwanted newsletters instead, to be 100% sure that you won't receive them again.`
}

const myInboxIsStillFullOfSpam = {
    ask: `My inbox is still full of spam`,
    answer: `Cleanfox doesn't clean up spam, it cleans up unwanted newsletters. However, we do offer tips on how to clean up your spam easily in our blog : [spam: the beginners guide](https://cleanfox.io/blog/spam-en/spam-the-beginners-guide/)`
}

const cleanfoxDidntClearOutMyMailboxIStillHaveALotOfEmails = {
    ask: `Cleanfox didn't clear out my mailbox. I still have a lot of emails.`,
    answer: `The deletion of emails after using Cleanfox is not always immediate. Indeed, it is likely that the process takes several days. 

We are currently working on a new feature to improve this. 

However, if the issue persists after waiting a long time, do not hesitate to contact us at [contact@cleanfox.io](mailto:contact@cleanfox.io). We will take care of it.`
}

const howCanIReferMyFriends = {
    ask: `How can I refer my friends?`,
    answer: `To sponsor a friend, we invite you to go to the Statistics tab of your application. In "Refer your friends", click on "Refer a friend", where you will find your referral code.

You can directly copy this code and send it to your friends or use the Twitter, Whatsapp or LinkedIn shortcuts.

Please note that this code only works if the person you refer is using Cleanfox for the first time.

🌱Cleanfox partners with WeForest and allows you to plant a m² of tree for each new person you refer.`
}

const howCanIBenefitFromAReferral = {
    ask: `How can I benefit from a referral?`,
    answer: `In order to be referred, you must use the referral code **when you first use Cleanfox**.

When you create your account, after entering your email and password, insert the referral code sent by your friend beforehand.`
}

const iAutomaticallyDeletedANewsletterByMistakeHowCanIRetrieveIt = {
    ask: `I automatically deleted a newsletter by mistake. How can I retrieve it?`,
    answer: `You can find all the newsletters that you have decided to keep or to which you have decided to block in **My Actions**, at the top right of your screen. Your newsletters are divided into two categories :

- **Newsletters automatically deleted**: this corresponds to the newsletters you have decided to block. By clicking on the pen at the bottom right of your screen, you can check the newsletters you want to retrieve. Be careful to validate your action by clicking on the green arrow at the bottom right of your screen.
- **retained newsletters** : this corresponds to the newsletters you have decided to keep. Here again, you can modify your action by deciding to put back the desired newsletters in your cleaning list.`
}

const iWouldLikeToDownloadMyPersonalDataHeldByCleanfox = {
    ask: `I would like to download my personal data held by Cleanfox.`,
    answer: `Within the framework of the GDPR regulation, all Cleanfox users can exercise their right of portability, offering the possibility of recovering part of their data in an open and machine-readable format.

To download your personal data, you must log in to your Cleanfox account. Once logged in, go to your Settings, then Privacy. At the bottom of the page, you will find a download link.

**Please note that you can only upload your personal data on the web (i.e. using your computer).**`
}

const whyDoIHaveToGoThroughATwoStepAuthentification = {
    ask: `Why do I have to go through a two-step authentification?`,
    answer: `Cleanfox has chosen to guarantee a higher level of confidentiality. To ensure the **security of its users** we have strengthened the audit of accounts. So we've added a few more steps during your registration. The advantage for you is that your account is more secure. Indeed, the two-step authentication allows you not to have to give us the password of your mailbox.

To securely connect your mailbox to Cleanfox, you will need to create a unique password, called an application password, which will allow Cleanfox to access your emails to be sorted without knowing your personal password.`
}

const howIsTheDataCollectedByCleanfoxUsed = {
    ask: `How is the data collected by Cleanfox used?`,
    answer: `Our anonymized data for statistical purpose are designed for companies willing to know more about their business, markets or competitors.

Three examples of applications:

- Determining market share: We are able to deduce the market share of companies in their sector based solely on receipts and order confirmations.
- Determining customer loyalty: We offer companies a view of their competitors from whom their customers order. In this way, we enable them to measure their customers' loyalty to their brand.
- Determining the sensitivity to a promotion: We are able to determine the impact of a promotion on the number of orders.

We made the choice to never use data for advertising purposes.

please visit this page [for more information](my-data)

ℹ️ At Cleanfox, we always let our users make their own choices. Indeed, if you do not want us to use your data for statistical purposes, you can opt out of the anonymised Foxintelligence panel. To do this, go to your Settings, Mailboxes, Foxintelligence Panel.`
}

const whatDataIsRecoveredByCleanfox = {
    ask: `What data is recovered by Cleanfox?`,
    answer: `Our algorithms are designed to only process newsletters and order confirmations.

First, we collect some basic contact information when creating your account. Then, with your consent, we connect Cleanfox to your mailbox(es). We have never sold, are not selling and will never sell personal data.

please visit this page [for more information](my-data).`
}

const canCleanfoxReadMyEmail = {
    ask: `Can Cleanfox read my email?`,
    answer: `In our automated process of processing newsletters and transactional data, all personal emails are ignored and excluded from any access by our systems. The extraction of transactional data is carried out by algorithms (regex type). These algorithms know exactly which order confirmation sender to look for (e.g., confirmation-commande@amazon.fr) and cannot under any circumstances extract unexpected data.
This data is non-personal, anonymized and has only one purpose: to be aggregated for market research on e-commerce.

Our company is based on the fundamental principles of never generating any harm to our users, never transmitting or exploiting their personal data and never feeding the advertising industry (audience, targeting cookies, etc.). Finally, we make it a point of honor to be transparent with our users at all times (based on clear consent).

please visit this page [for more information](my-data).`
}

const iWouldLikeToDeleteMyCleanfoxAccount = {
    ask: `I would like to delete my Cleanfox account`,
    answer: `To delete your account and all associated data, here's how to do it:

1. Login to your Cleanfox account
2. Click on **"My Settings",** then **"Your Mailboxes".**
3. Choose your email address to delete and click on **"Delete this mailbox".**

By clicking on "Delete this mailbox", your Cleanfox account and all associated data will be deleted. Attention, if you have recently performed a cleanup and it is not yet effective in your mailbox, the deletion of your account will cancel this cleanup.`
}

const howDoesCleanfoxConnectToMyMailbox = {
    ask: `How does Cleanfox connect to my mailbox?`,
    answer: `To log in, we use IMAP and the application password.`
}

const whyDoesMyEmailServiceWarnMeThatSomeoneIsUsingIMAPFromAnotherLocation = {
    ask: `Why does my email service warn me that someone is using IMAP from another location?`,
    answer: `We use IMAP to connect to your email inbox - no stress, everything is perfectly normal!`
}

const howDoIPlantSqmOfTreesWithCleanfox = {
    ask: `How do I plant m² of trees with Cleanfox?`,
    answer: `In addition to its mailbox cleaning service, Cleanfox wants to increase its positive impact on the environment. To do so, we have formed a partnership with the association WeForest to participate in the financing of a reforestation project in Zambia. Indeed, for each person sponsored on Cleanfox, one m² of tree is planted in Zambia.

To learn more about the WeForest project: [https://www.weforest.org/](https://www.weforest.org/).`
}

const canIReallyReduceMyCarbonFootprintByUsingCleanfox = {
    ask: `Can I really reduce my carbon footprint by using Cleanfox?`,
    answer: `Yes !

Since its launch, Cleanfox has deleted several hundred million emails, reducing the carbon footprint of its users. Thus, several tons of CO₂ have not been emitted thanks to Cleanfox. 

Also, thanks to our Stories feature, you can track your consumption every month and adapt it according to your goals.

More info on: [Why do emails pollute?](https://cleanfox.io/blog/carbon-impact/email-pollution-and-co2-emissions/)

The planet says thank you !`
}

const howDoEmailsContributeToDigitalPollution = {
    ask: `How do emails contribute to digital pollution?`,
    answer: `Email is part of the daily life of most digital users. One e-mail generates about 10 grams of CO2 per year. Does that sound small to you? Just bring it down to the scale of a country like France, which sends 1.4 billion emails per day!

Not only is the sending of e-mails a major factor in digital pollution, but their storage is also one. Indeed, only 60% of emails and 10% of newsletters are opened. This storage also costs the planet.

Thus, a Cleanfox user saves **on average 6kg of CO2 per year** by cleaning his mailbox. Clean your mailbox, you will directly reduce your carbon footprint!`
}

const andForMyEcommerceTransactionsWhatIsTheEcologicalImpact = {
    ask: `And for my e-commerce transactions, what is the ecological impact?`,
    answer: `With the explosion of e-commerce, online shopping is having an ever-increasing impact on the environment. From the online order to the delivery of the order, all steps contribute to polluting the planet. 

In the Stories, on your Statistics page, you can find tips on how to reduce your carbon footprint, as well as details on your online activity, in order to adapt your consumption according to your goals.`
}

const iWouldLikeToSuggestANewFeatureOrGiveYouMyOpinion = {
    ask: `I would like to suggest a new feature or give you my opinion`,
    answer: `At Cleanfox, we are very committed to the satisfaction of our users. We take all your comments and suggestions into consideration.

You can rate Cleanfox directly from your application in Settings → Rate Cleanfox.

You can also write to us at [contact@cleanfox.io](mailto:contact@cleanfox.io), we look forward to hearing from you!`
}

const iCantFindAnAnswerToMyIssueInTheFAQs = {
    ask: `I can't find an answer to my issue in the FAQs`,
    answer: `If you do not find answers to your questions in our FAQ, or if your issue requires assistance, you can contact us directly by email at the following address: [contact@cleanfox.io](mailto:contact@cleanfox.io) We generally respond within 24 to 48 hours.

❗️Technical support is only available in two languages: French and English. Please make sure to write your email in one of these two languages.`
}

const iWouldLikeToContactTechnicalSupport = {
    ask: `I would like to contact technical support`,
    answer: `To contact technical support, you need to send an email to : **[contact@cleanfox.io](mailto:contact@cleanfox.io).**

❗️Technical support is only available in two languages: French and English. Please make sure to write your email in one of these two languages.

In order to facilitate the technical support response, we recommend that you specify in your request :

- The support used: Mobile or computer?
    - If mobile: iOS or Android?
- Your email address
- Steps taken before meeting your problem
- If possible, a screenshot of your error/bug message

We usually respond within 24 to 48 hours maximum (business days).`
}

const faq = [
    {
        img: '/img/static/faq/ask.svg',
        title: 'Top questions',
        questions: [
            { ...howToCleanMyEmailsWithCleanfox},
            { ...cleanfoxDoesntRecognizeMyEmailAddress},
            { ...theScanRunsInALoop},
            { ...iForgotMyPassword},
            { ...iDeletedAnEmailByMistakeHowCanIRetrieveIt},
            { ...iWouldLikeToSortThroughSeveralMailboxesAtTheSameTime},
            { ...iWouldLikeToDeleteMyCleanfoxAccount},
            { ...howDoICreateACleanfoxAccountWithAGmailAddress},
            { ...howDoICreateACleanfoxAccountWithAMicrosoftAddress}
        ]
    },
    {
        img: '/img/static/faq/about.png',
        title: 'About Cleanfox',
        questions: [
            whoAreWe,
            howDoesCleanfoxWorks,
            howMuchDoesCleanfoxCost,
            whatLanguagesIsCleanfoxAvailableIn,
            howDoWeMakeMoney,
            whichDevicesCanIUseCleanfoxOn
        ]
    },
    {
        img: '/img/static/faq/connection.svg',
        title: 'Signing up',
        questions: [
            howDoIDownloadTheCleanfoxOnMyMobile,
            howDoICreateACleanfoxAccount,
            howDoesTheRegistrationProcessWork,
            iVeAlreadyUsedCleanfoxBeforeHowDoILogBackIn,
            iForgotMyPassword,
            cleanfoxDoesntRecognizeMyEmailAddress,
            theScanRunsInALoop,
            howDoICreateACleanfoxAccountWithAGmailAddress,
            howDoICreateACleanfoxAccountWithAMicrosoftAddress
        ]
    },
    {
        img: '/img/static/faq/usage.svg',
        title: 'Using Cleanfox',
        questions: [
            howToCleanMyEmailsWithCleanfox,
            iWouldLikeToSortThroughSeveralMailboxesAtTheSameTime,
            iWouldLikeToUnderstandMyStatistics,
            iDeletedAnEmailByMistakeHowCanIRetrieveIt,
            whyDoNewslettersThatIHaveDeletedStillAppearInMyMailbox,
            myInboxIsStillFullOfSpam,
            cleanfoxDidntClearOutMyMailboxIStillHaveALotOfEmails,
            howCanIReferMyFriends,
            howCanIBenefitFromAReferral,
            iAutomaticallyDeletedANewsletterByMistakeHowCanIRetrieveIt
        ]
    },
    {
        img: '/img/static/faq/privacy.svg',
        title: 'Security and Privacy',
        questions: [
            iWouldLikeToDownloadMyPersonalDataHeldByCleanfox,
            whyDoIHaveToGoThroughATwoStepAuthentification,
            howIsTheDataCollectedByCleanfoxUsed,
            whatDataIsRecoveredByCleanfox,
            canCleanfoxReadMyEmail,
            iWouldLikeToDeleteMyCleanfoxAccount,
            howDoesCleanfoxConnectToMyMailbox,
            whyDoesMyEmailServiceWarnMeThatSomeoneIsUsingIMAPFromAnotherLocation
        ]
    },
    {
        img: '/img/static/faq/pollution.svg',
        title: 'Digital Pollution',
        questions: [
            howDoIPlantSqmOfTreesWithCleanfox,
            canIReallyReduceMyCarbonFootprintByUsingCleanfox,
            howDoEmailsContributeToDigitalPollution,
            andForMyEcommerceTransactionsWhatIsTheEcologicalImpact
        ]
    },
    {
        img: '/img/static/faq/miscellaneous.svg',
        title: 'Miscellaneous',
        questions: [
            iWouldLikeToSuggestANewFeatureOrGiveYouMyOpinion,
            iCantFindAnAnswerToMyIssueInTheFAQs,
            iWouldLikeToContactTechnicalSupport
        ]
    }
]

export default faq

